import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";

import SignIn from "./SignIn";
import Home from "./Home";
import HomeListagem from "./Home/Listagem";
import Produto from "./Home/Produto";
import Perfil from "./Home/Perfil";
import Pedidos from "./Home/Pedidos";
import PedidosDetalhes from "./Home/Pedidos/Detalhe";
import Carrinho from "./Home/Carrinho";
import Admin from "./Admin";
import AdminDashboard from "./Admin/Dashboard";
import AdminProdutos from "./Admin/Produtos";
import AdminPedidos from "./Admin/Pedidos";
import AdminUsuarios from "./Admin/Usuarios";
import AdminNovoProduto from "./Admin/Produtos/Novo";
import AdminProdutoInteressados from "./Admin/Produtos/Interessados";
import AdminNovoUsuario from "./Admin/Usuarios/Novo";
import { ROLES } from "../utils/constants";
import ResetPassword from "./ResetPassword";
import Extrato from "./Home/Extrato";
import AdminOrgaDots from "./Admin/OrgaDots";
import { ConfirmProvider } from "../components/ConfirmProvider";

export const SearchContext = React.createContext(null);
const AppRoutes = () => {
  const [needle, setNeedle] = React.useState("");
  const state = useSelector((state) => state);
  const { authReducer } = state;
  console.log("state", state);
  const { isAuthenticated, admin, user } = authReducer;
  const adminPanel =
    user?.roles?.includes(ROLES.admin) || user?.roles?.includes(ROLES.gestor);

  return (
    <SearchContext.Provider value={{ needle, setNeedle }}>
      <ConfirmProvider>
      <Routes>
        {!isAuthenticated ? (
          <>
            <Route path="/" element={<SignIn />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
          </>
        ) : (
          <>
            <Route path="/sign-in" element={<SignIn />} />
            <Route
              path="/reset-password/:token"
              element={<Navigate to="/" />}
            />
            {adminPanel ? (
              <>
                {/* // redirects to /admin/dashboard if the user is authenticated and an admin */}
                <Route path="/" element={<Navigate to="/admin" />} />
                <Route path="/admin" element={<Admin />}>
                  <Route
                    index
                    element={admin ? <AdminDashboard /> : <AdminPedidos />}
                  />
                  {/* <Route path="dashboard" element={<Admin.Dashboard />} /> */}
                  {admin && (
                    <>
                      <Route path="dashboard" element={<AdminDashboard />} />
                      <Route path="produtos" element={<AdminProdutos />} />
                      <Route
                        path="produtos/novo"
                        element={<AdminNovoProduto />}
                      />
                      <Route
                        path="produtos/editar/:id"
                        element={<AdminNovoProduto edit={true} />}
                      />
                      <Route
                        path="produtos/:id/interessados"
                        element={<AdminProdutoInteressados />}
                      />
                    </>
                  )}
                  <Route
                    path="vitrine"
                    element={<HomeListagem readOnly={true} />}
                  />
                  <Route
                    path="vitrine/produto/:id"
                    element={<Produto readOnly={true} />}
                  />
                  <Route path="pedidos" element={<AdminPedidos />} />
                  <Route path="usuarios" element={<AdminUsuarios />} />
                  <Route path="usuarios/novo" element={<AdminNovoUsuario />} />
                  <Route
                    path="usuarios/editar/:id"
                    element={<AdminNovoUsuario />}
                  />

                  <Route path="orgadots" element={<AdminOrgaDots />} />
                  <Route path="perfil" element={<Perfil />} />
                  <Route path="extrato" element={<Extrato />} />
                </Route>
              </>
            ) : (
              <Route path="/" element={<Home />}>
                <Route index element={<HomeListagem />} />
                <Route path="/listagem" element={<HomeListagem />} />
                <Route path="/produto/:id" element={<Produto />} />
                <Route path="/perfil" element={<Perfil />} />
                <Route path="/pedidos" element={<Pedidos />} />
                <Route path="/pedidos/:id" element={<PedidosDetalhes />} />
                <Route path="/carrinho" element={<Carrinho />} />
                <Route path="/extrato" element={<Extrato />} />
              </Route>
            )}
          </>
        )}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>
      </ConfirmProvider>
    </SearchContext.Provider>
  );
};

export default AppRoutes;
